const INTEGRATION_EDUCATION_EMPLOYEES = 'employees';
const INTEGRATION_EDUCATION_POSITIONS = 'positions';
const INTEGRATION_EDUCATION_LOCATIONS = 'locations';
const INTEGRATION_EDUCATION_TIMESHEETS = 'timesheets';
const INTEGRATION_EDUCATION_SALES = 'sales';
const INTEGRATION_EDUCATION_PREFIX = 'integration-education';

const stepTypes = {
  [INTEGRATION_EDUCATION_EMPLOYEES]: INTEGRATION_EDUCATION_EMPLOYEES,
  [INTEGRATION_EDUCATION_POSITIONS]: INTEGRATION_EDUCATION_POSITIONS,
  [INTEGRATION_EDUCATION_LOCATIONS]: INTEGRATION_EDUCATION_LOCATIONS,
  [INTEGRATION_EDUCATION_SALES]: INTEGRATION_EDUCATION_SALES,
  [INTEGRATION_EDUCATION_TIMESHEETS]: INTEGRATION_EDUCATION_TIMESHEETS,
};

export default class IntegrationsEducationService {
  modal;
  status = null;
  integrationType = null;
  modalData = {
    status: null,
    details: null,
  };

  constructor($rootScope, $uibModal, Authentication, IntegrationService, Education) {
    'ngInject';

    Object.assign(this, { $rootScope, $uibModal, Authentication, IntegrationService, Education });

    this.init();
  }

  stepTypes = stepTypes;

  get clientFlags() {
    return this.Authentication.user.settings.clientFlags;
  }

  init() {
    this.$rootScope.$on('education:hide', (e, { config: cfg }) => {
      if (cfg.name?.startsWith(INTEGRATION_EDUCATION_PREFIX)) {
        this.clientFlags[cfg.name] = true;
        this.Authentication.syncSettings();
      }
    });
  }

  getStep(integration, stepType) {
    if (!integration || !stepType) {
      return null;
    }

    const name = integration.name;
    const frequencyMessage = name === 'Toast' ? '' : ' within 15 minutes';
    const steps = {
      [INTEGRATION_EDUCATION_EMPLOYEES]: {
        content: `
          <p class="semi-bold">Sling is automatically syncing employee information from ${name}. Once updates are made there, they will be reflected on Sling within 15 minutes.</p>
        `,
        name: this.getFullStepName(integration, INTEGRATION_EDUCATION_EMPLOYEES),
        selector: '#employees-count-header',
        chevron: 'left-top',
        offset: { y: 21, x: -5 },
      },
      [INTEGRATION_EDUCATION_POSITIONS]: {
        content: `
          <p class="semi-bold">Sling is automatically syncing position information from ${name}. Once updates are made there, they will be reflected on Sling within 15 minutes.</p>
        `,
        name: this.getFullStepName(integration, INTEGRATION_EDUCATION_POSITIONS),
        selector: '#positions-count-header',
        chevron: 'left-top',
        offset: { y: 21, x: -5 },
      },
      [INTEGRATION_EDUCATION_LOCATIONS]: {
        content: `
          <p class="semi-bold">Sling is automatically syncing location information from ${name}. Once updates are made there, they will be reflected on Sling within 15 minutes.</p>
        `,
        name: this.getFullStepName(integration, INTEGRATION_EDUCATION_LOCATIONS),
        selector: '#locations-count-header',
        chevron: 'left-top',
        offset: { y: 21, x: -5 },
      },
      [INTEGRATION_EDUCATION_TIMESHEETS]: {
        content: `
          <p class="semi-bold">Sling is automatically syncing timesheets from ${name}. Once employees clock in and clock out on ${name} POS, their times will be reflected on Sling${frequencyMessage}.</p>
        `,
        name: this.getFullStepName(integration, INTEGRATION_EDUCATION_TIMESHEETS),
        selector: '#timesheets-first-column',
        chevron: 'left-top',
        offset: { y: 15, x: -25 },
      },
      [INTEGRATION_EDUCATION_SALES]: {
        content: `
          <p class="semi-bold">Sling is automatically syncing sales information from ${name}. Once new sales are recorded there, they will be reflected on Sling within 15 minutes.</p>
        `,
        name: this.getFullStepName(integration, INTEGRATION_EDUCATION_SALES),
        selector: '#sales-first-column',
        chevron: 'left-top',
        offset: { y: 15, x: -35 },
      },
    };

    return steps[stepType];
  }

  getFullStepName(integration, stepType) {
    return `${INTEGRATION_EDUCATION_PREFIX}-${integration?.name}-${stepType}`;
  }

  async showStep(integrationPlatform, stepType) {
    const integration = await this.IntegrationService.getIntegrationByPlatform(integrationPlatform);
    if (!integration || !integration.enabled) {
      return;
    }

    const stepFullName = this.getFullStepName(integration, stepType);
    if (!this.clientFlags[stepFullName]) {
      const step = this.getStep(integration, stepType);
      if (step) {
        this.Education.show(step);
      }
    }
  }
}
